import {
  buildGroupScopeKey,
  CLIENT_SCOPE,
  isSameScope,
  parseScopeClientId,
} from '@modules/consolidator/utils/Api/Api'
import { buildEmptyGroupAvisos } from '@modules/consolidator/utils/adapt-group-wallet-analysis-response/adapt-group-wallet-analysis-response'
import { FILTER_MODE } from '@modules/consolidator/constants/filter-mode'

const currentGroupOnScreen = (rootGetters) =>
  (rootGetters && rootGetters['consolidator/currentFamilyGroup']) || null

const isCurrentWalletScope = (scopeKey, rootGetters) => {
  const grupo = currentGroupOnScreen(rootGetters)
  if (grupo) return isSameScope(scopeKey, buildGroupScopeKey(grupo.id))
  if (scopeKey === CLIENT_SCOPE) return true
  const currentClient = (rootGetters && rootGetters['user/currentClient']) || {}
  if (!currentClient.id) return false
  if (scopeKey == null) return false
  return parseScopeClientId(scopeKey) === String(currentClient.id)
}

// Getters
export const viewMode = (state) => {
  return (state.preferences && state.preferences.viewMode) || 'estrategica'
}

export const consolidateExtracts = (state) => {
  return state.consolidateExtracts.data || []
}
export const consolidateExtractsLoading = (state) => {
  return state.consolidateExtracts.loading
}
export const consolidateExtractsLastUpdate = (state) => {
  return state.consolidateExtracts.lastUpdate
}

export const cotizacao = (state) => (id) => {
  return state.cotizacao.data[id] || false
}
export const cotizacaoLoading = (state) => {
  return state.cotizacao.loading
}
export const cotizacaoLastUpdate = (state) => {
  return state.cotizacao.lastUpdate
}

export const overview = (state) => {
  return state.overview.data || []
}
export const overviewLoading = (state) => {
  return state.overview.loading
}
export const overviewLastUpdate = (state) => {
  return state.overview.lastUpdate
}

export const overviewFilters = (state) => {
  return state.overviewFilters.data || []
}
export const overviewFiltersLoading = (state) => {
  return state.overviewFilters.loading
}
export const overviewFiltersLastUpdate = (state) => {
  return state.overviewFilters.lastUpdate
}

export const assetsLiquidity = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.assetsLiquidity.clientId, rootGetters))
    return []
  return state.assetsLiquidity.data || []
}
export const assetsLiquidityLoading = (state) => {
  return state.assetsLiquidity.loading
}
export const assetsLiquidityLastUpdate = (state) => {
  return state.assetsLiquidity.lastUpdate
}
export const assetsLiquidityClientId = (state) => state.assetsLiquidity.clientId

export const clientAssets = (state) => {
  return state.clientAssets.data || []
}
export const clientAssetsLoading = (state) => {
  return state.clientAssets.loading
}
export const clientAssetsLastUpdate = (state) => {
  return state.clientAssets.lastUpdate
}

export const searchAssets = (state) => {
  return state.searchAssets.data || []
}
export const searchAssetsLoading = (state) => {
  return state.searchAssets.loading
}
export const searchAssetsLastUpdate = (state) => {
  return state.searchAssets.lastUpdate
}

// Se os dados do cliente estao desatualizados
export const clientDataOutdated = (state) => {
  return state.clientsDataOutdated.data || false
}

export const recotizacaoEmAndamento = (state) => {
  return state.recotizacaoEmAndamento.data || null
}

export const recentlyLinkedAssetIds = (state) => {
  return state.recentlyLinkedAssetIds || []
}

export const versionClosing = (state) => {
  return state.versionClosing.data || []
}
export const versionClosingLoading = (state) => {
  return state.versionClosing.loading
}
export const versionClosingLastUpdate = (state) => {
  return state.versionClosing.lastUpdate
}

export const backOfficeComparison = (state) => {
  return state.backOfficeComparison.data || []
}
export const backOfficeComparisonLoading = (state) => {
  return state.backOfficeComparison.loading
}
export const backOfficeComparisonLastUpdate = (state) => {
  return state.backOfficeComparison.lastUpdate
}

export const investmentAccount = (state) => {
  return state.investmentAccount.data || []
}
export const investmentAccountLoading = (state) => {
  return state.investmentAccount.loading
}
export const investmentAccountLastUpdate = (state) => {
  return state.investmentAccount.lastUpdate
}

export const fullWallet = (state) => {
  return state.fullWallet.data || []
}
export const fullWalletLastUpdate = (state) => {
  return state.fullWallet.lastUpdate
}

export const fullWalletBrokers = (state) => {
  return state.fullWallet.brokers || []
}

export const fullWalletPortfolio = (state) => {
  return state.fullWallet.portfolios || []
}
export const correlations = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.correlations.clientId, rootGetters)) return []
  return state.correlations.data || []
}
export const correlationsLoading = (state) => {
  return state.correlations.loading
}
export const correlationsLastUpdate = (state) => {
  return state.correlations.lastUpdate
}
export const correlationsClientId = (state) => state.correlations.clientId

export const riskMetrics = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.riskMetrics.clientId, rootGetters)) return []
  return state.riskMetrics.data || []
}
export const riskMetricsLoading = (state) => {
  return state.riskMetrics.loading
}
export const riskMetricsLastUpdate = (state) => {
  return state.riskMetrics.lastUpdate
}
export const riskMetricsClientId = (state) => state.riskMetrics.clientId

export const InsightsIa = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.InsightsIa.clientId, rootGetters)) return []
  return state.InsightsIa.data || []
}
export const InsightsIaLoading = (state) => {
  return state.InsightsIa.loading
}
export const InsightsIaLastUpdate = (state) => {
  return state.InsightsIa.lastUpdate
}
export const InsightsIaClientId = (state) => state.InsightsIa.clientId
export const analisysAdvanced = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.analisysAdvanced.clientId, rootGetters))
    return []
  return state.analisysAdvanced.data || []
}
export const analisysAdvancedLoading = (state) => {
  return state.analisysAdvanced.loading
}
export const analisysAdvancedLastUpdate = (state) => {
  return state.analisysAdvanced.lastUpdate
}
export const analisysAdvancedClientId = (state) =>
  state.analisysAdvanced.clientId

export const carteiraAtivos = (state) => {
  return state.carteiraAtivos.data || []
}
export const carteiraAtivosLoading = (state) => {
  return state.carteiraAtivos.loading
}
export const carteiraAtivosLastUpdate = (state) => {
  return state.carteiraAtivos.lastUpdate
}

export const investmentAccounts = (state) => {
  return state.investmentAccounts.data || []
}
export const investmentAccountsLoading = (state) => {
  return state.investmentAccounts.loading
}
export const investmentAccountsLastUpdate = (state) => {
  return state.investmentAccounts.lastUpdate
}

export const simulatorResult = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.simulatorResult.clientId, rootGetters))
    return []
  return state.simulatorResult.data || []
}
export const simulatorResultLoading = (state) => {
  return state.simulatorResult.loading
}
export const simulatorResultLastUpdate = (state) => {
  return state.simulatorResult.lastUpdate
}
export const simulatorResultClientId = (state) => state.simulatorResult.clientId

export const walletFiltersModo = (state) => {
  return state.walletFilters.data.modoFiltroCorretora
}
export const walletFiltersCorretora = (state) => {
  return state.walletFilters.data.filtroCorretora
}
export const walletFiltersData = (state) => {
  return state.walletFilters.data.filtroData
}
export const walletFiltersInvestmentType = (state) => {
  return state.walletFilters.data.investmentTypeFilter
}
export const walletFiltersLastValidData = (state) => {
  return state.walletFilters.data.lastValidFiltroData
}
export const walletFiltersDataInicio = (state) => {
  return state.walletFilters.data.dataInicio
}
export const walletFiltersDataFim = (state) => {
  return state.walletFilters.data.dataFim
}
export const walletFiltersTipo = (state) => state.walletFilters.data.tipo
export const walletFiltersSubtipo = (state) => state.walletFilters.data.subtipo
export const walletFiltersClasse = (state) => state.walletFilters.data.classe
export const walletFiltersSubclasse = (state) =>
  state.walletFilters.data.subclasse
export const walletFiltersSetor = (state) => state.walletFilters.data.setor
export const walletFiltersEmissor = (state) => state.walletFilters.data.emissor
export const walletFiltersIdConta = (state) => state.walletFilters.data.idConta
export const walletFiltersTags = (state) => state.walletFilters.data.tags
export const walletFiltersInstituicao = (state) =>
  state.walletFilters.data.instituicao
export const walletFiltersPortfolio = (state) =>
  state.walletFilters.data.portfolio
export const walletFiltersUserChangedField = (state) => (key) => {
  const changed = state.walletFilters.data.userChangedFields || {}
  return !!changed[key]
}
export const walletFiltersAll = (state) => {
  return { ...state.walletFilters.data }
}

export const walletAnalysis = (state) => {
  return state.walletAnalysis.data || null
}
export const walletAnalysisLoading = (state) => {
  return state.walletAnalysis.loading
}
export const walletAnalysisLastUpdate = (state) => {
  return state.walletAnalysis.lastUpdate
}

export const walletAnalysisOptionsFields = (state) =>
  state.walletAnalysisOptionsFields.data || []
export const walletAnalysisOptionsFieldsLoading = (state) =>
  !!state.walletAnalysisOptionsFields.loading

export const statisticsPerAsset = (state, getters, rootState, rootGetters) => {
  if (!isCurrentWalletScope(state.statisticsPerAsset.clientId, rootGetters)) {
    return {}
  }
  return state.statisticsPerAsset.data || {}
}
export const statisticsPerAssetLoading = (state) =>
  !!state.statisticsPerAsset.loading
export const statisticsPerAssetLastUpdate = (state) =>
  state.statisticsPerAsset.lastUpdate
export const statisticsPerAssetClientId = (state) =>
  state.statisticsPerAsset.clientId

export const assetSeries = (state) => state.assetSeries.data || {}
export const assetSeriesLastUpdate = (state) => state.assetSeries.lastUpdate
export const assetSeriesBenchmarks = (state) =>
  state.assetSeriesBenchmarks.data || {}

export const portfolios = (state) => {
  return state.portfolios.data || []
}
export const portfoliosLoading = (state) => {
  return state.portfolios.loading
}
export const portfoliosLastUpdate = (state) => {
  return state.portfolios.lastUpdate
}

export const proventos = (state) => {
  return state.proventos.data || {}
}
export const proventosLoading = (state) => {
  return state.proventos.loading
}
export const proventosLastUpdate = (state) => {
  return state.proventos.lastUpdate
}
export const proventosClientId = (state) => {
  return state.proventos.clientId
}

export const splits = (state) => {
  return state.splits.data || {}
}
export const splitsLoading = (state) => {
  return state.splits.loading
}
export const splitsLastUpdate = (state) => {
  return state.splits.lastUpdate
}
export const splitsClientId = (state) => {
  return state.splits.clientId
}

export const walletSelectorMode = (state) => {
  return state.walletSelectorMode.data || FILTER_MODE.CLIENTES
}

export const isFamilyGroupView = (state) => {
  return state.walletSelectorMode.data === FILTER_MODE.FAMILIAS
}

export const currentFamilyGroup = (state) => {
  return state.currentFamilyGroup.data || null
}

export const familyGroupWalletData = (state) => {
  return state.familyGroupWallet.data || null
}
export const familyGroupLoading = (state) => {
  return Boolean(state.familyGroupWallet.loading)
}
export const familyGroupWalletLastUpdate = (state) => {
  return state.familyGroupWallet.lastUpdate
}

export const familyGroupAssetStatistics = (state) => {
  return state.familyGroupAssetStatistics.data || {}
}
export const familyGroupAssetStatisticsLoading = (state) => {
  return Boolean(state.familyGroupAssetStatistics.loading)
}
export const familyGroupAssetStatisticsLastUpdate = (state) => {
  return state.familyGroupAssetStatistics.lastUpdate
}

/**
 * Breakdown por MEMBRO, carregado à parte do payload principal.
 *
 * A seção "Por Carteira" é fixa na tela, mas o `breakdown` do payload vem na
 * dimensão que o usuário escolheu em "Agrupar por" — com Subclasse (o padrão)
 * não existe nenhuma entrada por membro, e a seção ficava vazia pedindo pro
 * usuário trocar o filtro. Este slot guarda a carga paralela com
 * `group_by=id_cliente`, então a tabela dos membros vive independente do
 * agrupamento escolhido.
 */
export const familyGroupMemberBreakdown = (state) => {
  const payload = state.familyGroupMemberBreakdown.data
  return (payload && payload.breakdown) || null
}
export const familyGroupMemberBreakdownLoading = (state) => {
  return Boolean(state.familyGroupMemberBreakdown.loading)
}
export const familyGroupMemberBreakdownLastUpdate = (state) => {
  return state.familyGroupMemberBreakdown.lastUpdate
}

export const familyGroupFilters = (state) => {
  return state.familyGroupFilters.data || {}
}

export const familyGroupOptionsFields = (state) => {
  return state.familyGroupOptionsFields.data || []
}
export const familyGroupOptionsFieldsLoading = (state) => {
  return Boolean(state.familyGroupOptionsFields.loading)
}

// Todos os membros do grupo, incluídos ou não no cálculo. A marcação de quem
// entrou vem pronta do backend (`incluido` / `motivo_exclusao`).
export const familyGroupMembros = (state) => {
  const wallet = state.familyGroupWallet.data
  if (!wallet) return []
  return Array.isArray(wallet.membros) ? wallet.membros : []
}

// As cinco chaves de aviso sempre presentes como array — a UI nunca precisa de
// encadeamento opcional, que o Babel do projeto não transpila.
export const familyGroupAvisos = (state) => {
  const wallet = state.familyGroupWallet.data
  if (!wallet || !wallet.avisos) return buildEmptyGroupAvisos()
  return wallet.avisos
}
